
<div class="login-page">
    <div class="login-box">
        <div class="login-logo">
            <img src="../../assets/img/ImgAlanser.png" width="150" alt="Cave San José" class="brand-image ielevation-3">
          </div>
        <div class="card">
            <div class="card-body login-card-body">
                <p class="login-box-msg">{{nomusu}}</p>
                <form name="form" #f="ngForm" novalidate>
                    <div class="form-group input-group mb-3">
                        <input type="password" class="form-control" 
                               placeholder="Nueva contraseña" 
                               autocomplete="off"  
                               name="nuevaclv1" 
                               [(ngModel)]="nuevaclv1"
                               (focus)="reset()"
                               required  
                               autofocus/> 
                        <div class="input-group-append">
                            <div class="input-group-text">
                                <fa-icon [icon]="icoClv"></fa-icon> 
                            </div>
                        </div>
                    </div>
                    <div class="form-group input-group mb-3">
                        <input type="password" class="form-control" 
                               placeholder="Confirme contraseña" 
                               autocomplete="off"  
                               name="nuevaclv2" 
                               [(ngModel)]="nuevaclv2"
                               (focus)="reset()"
                               required /> 
                        <div class="input-group-append">
                            <div class="input-group-text">
                                <fa-icon [icon]="icoClv"></fa-icon> 
                            </div>
                        </div> 
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <button  class="btn btn-cave btn-block" (click)="validar()">
                                <fa-icon [icon]="icoVal"></fa-icon>  Cambiar contraseña
                            </button>
                        </div>
                    </div>
                    <div *ngIf="resul" class="spinner-border text-primary" role="status"></div>
                </form>
                <div class="ponError">
                 <span *ngIf="xErro" >{{xErro}}</span> 
              </div>               
            </div>
        </div>
        <div class="nota">
            <span>
                La contraseña debe contener al menos 6 caracteres, combinando números, letras y caracteres especiales
            </span>
          </div>

    </div>
 </div>
